import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LeadState {
  id: number;
  firstname: string;
  lastname: string;
  leadName: string;
  number: string;
}

const initialState: LeadState = {
  id: 0,
  firstname: "",
  lastname: "",
  leadName: "",
  number: "",
};

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    // Set the lead data
    setLead: (state, action: PayloadAction<LeadState>) => {
      state.id = action.payload.id;
      state.firstname = action.payload.firstname;
      state.lastname = action.payload.lastname;
      state.leadName = action.payload.leadName;
      state.number = action.payload.number;
    },
    // Reset the lead data to initial state
    resetLead: () => initialState,
  },
});

export const { setLead, resetLead } = leadSlice.actions;

export default leadSlice.reducer;
